module.exports = __webpack_public_path__ + "img/shangku.c42e9599.svg";